export const styles = {
  mainContainer: {
    label: 'homeMainContainer',
    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
      display: 'none'
    },
    '& *': {
      msOverflowStyle: 'none',
      scrollbarWidth: 'none'
    },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    minWidth: '100%',
    height: '100%',
    position: 'absolute',
    alignItems: ['center', 'center', 'center', 'center', 'flex-start'],
    flexDirection: [
      'column-reverse',
      'column-reverse',
      'column-reverse',
      'column-reverse',
      'row',
      'row'
    ],
    '@media only screen and (orientation: landscape)': {
      flexDirection: 'row'
    },
    width: '100%',
    '& > video': {
      objectFit: 'cover',
      width: '100vw',
      height: [
        'calc(100vh - 48px)',
        'calc(100vh - 48px)',
        '100vh',
        '100vh',
        '100vh'
      ],
      minHeight: ['auto', 'auto', '100vh', '100vh', '100vh'],
      position: ['static', 'static', 'static', 'static', 'fixed', 'fixed'],
      top: 0,
      left: 0,
      zIndex: 0
    },
    maxHeight: '100%'
  },
  dhImageContainer: {
    alignItems: 'flex-end',
    justifyContent: 'center',
    label: 'dhImageContainer',
    flexBasis: ['50%', '50%', '50%', '50%', '50%', '70%'],
    height: '100%',
    '@media only screen and (orientation: landscape)': {
      display: ['none', 'flex', 'flex', 'flex', 'flex']
    }
  },
  dhImage: {
    objectFit: 'cover',
    width: '100%',
    maxHeight: ['300px', '300px', '900px', '900px', '100%'],
    transition: 'filter 0.25s ease-in-out',
    '@media only screen and (orientation: portrait)': {
      maxHeight: ['400px', '400px', '500px', '500px', '100%'],
      objectFit: 'contain'
    },
    '@media only screen and (orientation: landscape)': {
      maxHeight: ['400px', '400px', '500px', '500px', '100%'],
      objectFit: 'cover'
    }
  },
  content: {
    alignItems: ['flex-start', 'flex-start', 'flex-start', 'center', 'center'],
    label: 'content',
    flexBasis: ['auto', 'auto', '50%'],
    height: '100%',
    '@media only screen and (orientation: landscape)': {
      flexBasis: '100%',
      alignItems: ['flex-start', 'flex-start', 'center', 'center', 'center']
    }
  },
  textContainer: {
    label: 'text-container',
    mb: [4, 0],
    pl: ['10%', '10%', '10%', '10%', '5%', '5%'],
    pr: ['10%', '10%', '10%', '10%', '20%', '35%'],
    mx: ['0 auto', '0 auto', '0 auto', '0 auto', 'inherit'],
    mt: ['10%', '10%', 0],
    height: ['1px', '1px', 'auto', 'auto', 'auto', 'auto'],
    color: 'textAlternate',
    textAlign: 'left',
    zIndex: 4,
    maxHeight: '100%',
    flexDirection: 'column',
    flexBasis: ['100%', '100%', '100%', '100%', '80%'],
    overflowY: ['visible', 'visible', 'visible', 'visible', 'scroll', 'scroll']
  },
  heading: {
    color: 'textAlternate',
    display: 'flex',
    fontSize: [36, 36, 78, 78, 78],
    lineHeight: ['40px', '40px', '80px', '80px', '80px'],
    mt: [0, 0, 0, 0, 0, 15],
    fontWeight: 'bold',
    '@media only screen and (orientation: landscape)': {
      fontSize: [24, 24, 24, 24, 78],
      lineHeight: ['30px', '30px', '30px', '30px', '80px']
    }
  },
  subtitle: {
    fontWeight: '400',
    color: 'textAlternate',
    fontSize: [3, 3, 3, 4, 4]
  },
  letsChatButtonContainer: {
    label: 'lets-chat-button-container',
    display: ['flex', 'flex', 'flex', 'flex', 'block'],

    width: ['100%', '100%', '100%', '100%', '100%'],
    left: 0,
    '@media only screen and (orientation: landscape)': {
      position: 'inherit',
      bottom: 'inherit'
    }
  },
  letsChatButton: {
    lineHeight: '24px',
    fontWeight: '600',
    minWidth: '10rem',
    py: [3, 2],
    px: [6, 5],
    mb: 10,
    mt: 10,
    '@media only screen and (orientation: portrait)': {
      mb: [10, 40, 150, 150, 40]
    }
  },

  privacyTextToggle: {
    fontWeight: '300',
    cursor: 'pointer',
    fontSize: 0,
    lineHeight: '22px',
    textDecoration: 'none',
    maxWidth: 420
  },
  disclaimer: {
    mt: 9,
    mb: 6,
    fontWeight: '300',
    fontSize: 0,
    lineHeight: '22px',
    '& a, & a:active': {
      color: 'primary',
      textDecoration: 'none'
    },
    '& a:hover': {
      textDecoration: 'underline'
    },
    maxWidth: 480
  },
  recaptchaDisclaimer: {
    fontWeight: '300',
    fontSize: 0,
    lineHeight: '22px',
    mb: 14
  },
  surveyToggle: {
    fontWeight: 'bold',
    cursor: 'pointer',
    fontSize: 2,
    lineHeight: '24px',
    textDecoration: 'none',
    mb: 2,
    mt: [10, 10, 10, 10, 0, 0],
    pt: [10, 10, 10, 10, 0, 0]
  },
  togglePrivacyIcon: {
    display: 'inline-block',
    color: 'primary'
  },
  surveyContainer: {
    transition: 'max-height .5s linear',
    overflow: 'hidden',
    '& label': {
      fontWeight: '300',
      fontSize: 2,
      alignItems: 'flex-start',
      lineHeight: '24px'
    },
    '& textarea': {
      borderRadius: 'button',
      borderColor: 'grey',
      backgroundColor: 'white'
    },
    maxWidth: 440
  },
  checkbox: {
    width: '20px',
    height: '20px',
    borderRadius: 'button',
    'input:checked ~ &': {
      color: 'text',
      backgroundColor: 'white'
    }
  },
  textarea: {
    color: 'text',
    fontSize: 1
  },
  paragraphContainer: {
    transition: 'max-height .5s linear',
    fontSize: '12px',
    lineHeight: '18px',
    flexDirection: 'column',
    fontWeight: '300',
    px: 0,
    mt: 2,
    '& p': {
      mb: 3
    },
    maxWidth: ['100%', '100%', '100%', '100%', 480]
  },
  mobileParagraphsContainer: {
    zIndex: 9,
    color: 'white',
    textAlign: 'center',
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    backgroundColor: 'rgba(0,0,0,0.9)',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: '300',
    fontSize: 4,
    px: 7,
    my: 2,
    '& p': {
      my: 3
    }
  },
  privacyPolicyLink: {
    textDecoration: 'underline',
    color: 'currentColor',
    '&:hover': {
      color: 'primaryLight'
    }
  },
  titleContainer: {
    display: 'flex',
    width: '100%'
  }
}
export default styles
